import { Box, HStack, Skeleton, SkeletonCircle, Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  alignItemsTitle?: string;
};

const WholenessOverviewSkeleton = ({ alignItemsTitle = 'flex-start' }: Props) => {
  return (
    <Box borderRadius="20px" p="24px" bg="white" height={'600px'} boxShadow="0px 10px 40px 0px #00417926">
      <VStack gap={'10px'} alignItems={alignItemsTitle}>
        <Text variant={'urbanistBold20'} color={'text.darkBlue'} marginTop={'4px'}>
          Score
        </Text>
        <Text variant={'urbanistMedium'} color={'text.mediumGray'}>
          Here you will see the wholeness overview.
        </Text>
      </VStack>
      <VStack align="start" spacing="5" marginTop={'24px'}>
        <Skeleton height="18px" width="160px" mt="2" borderRadius={'6px'} />
        <VStack align="start" spacing="3" mt="4">
          {Array.from({ length: 6 }).map((_, i) => (
            <HStack key={i} spacing="10px">
              <SkeletonCircle height="20px" width={'20px'} />
              <Skeleton height="16px" width="260px" borderRadius={'4px'} />
            </HStack>
          ))}
        </VStack>
        <Skeleton height="18px" width="180px" mt="4" borderRadius={'6px'} />
        <Skeleton height="18px" width="220px" mt="4" borderRadius={'6px'} />

        <Skeleton height="54px" width="290px" mt="14" borderRadius="8px" />
      </VStack>
    </Box>
  );
};

export default WholenessOverviewSkeleton;
